import { styled } from 'styled-components';

export const Field = styled.div`
  min-width: 220px;
  max-width: 100%;
`;
